import React from 'react';
import { X, Download, User, Phone, Mail } from 'lucide-react';

const CandidatoDetalle = ({ candidato, isOpen, onClose }) => {
  if (!isOpen || !candidato) return null;

  return (
    <div className="fixed inset-y-0 right-0 w-[400px] bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-50 border-l border-gray-200">
      <div className="p-4 border-b flex justify-between items-center bg-gray-50">
        <h2 className="font-bold text-gray-700 uppercase text-sm">Detalle del Candidato</h2>
        <X className="cursor-pointer text-gray-400 hover:text-gray-600" onClick={onClose} />
      </div>

      <div className="p-6 overflow-y-auto h-full pb-24">
        {/* Info Principal */}
        <div className="flex flex-col items-center mb-6">
          <div className="w-20 h-20 bg-emeral-green bg-opacity-20 rounded-full flex items-center justify-center mb-4">
            {candidato.foto_url ? (
              <img src={candidato.foto_url} alt={candidato.nombre} className="w-full h-full object-cover rounded-full" />
            ) : (
              <User size={40} className="text-emeral-green" />
            )}
          </div>
          <h3 className="text-xl font-bold text-gray-800">{candidato.nombre}</h3>
          <span className="text-xs font-bold text-emeral-green uppercase bg-emeral-green bg-opacity-10 px-3 py-1 rounded-full mt-2">
            {candidato.etapa_actual}
          </span>
        </div>

        {/* Info Contacto */}
        <div className="space-y-4 mb-6">
          <div className="flex items-center gap-3 text-gray-600">
            <Mail size={16} className="text-gray-400" />
            <span className="text-sm">{candidato.email}</span>
          </div>
          <div className="flex items-center gap-3 text-gray-600">
            <Phone size={16} className="text-gray-400" />
            <span className="text-sm">{candidato.telefono || 'No registrado'}</span>
          </div>
        </div>

        {/* Documentos Adjuntos */}
        <div className="border-t pt-6">
          <h4 className="text-xs font-bold text-gray-500 uppercase mb-3">Documentos Adjuntos</h4>
          
          <div className="border border-gray-200 rounded-lg p-3 flex justify-between items-center bg-gray-50">
            <div className="flex flex-col">
              <span className="text-sm font-bold text-gray-700">Curriculum Vitae</span>
              <span className="text-xs text-gray-500">Documento PDF</span>
            </div>
            
            {candidato.cv_url ? (
              <a 
                href={`http://localhost:5000${candidato.cv_url}`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-emeral-green text-white p-2 rounded hover:bg-opacity-90 transition flex items-center justify-center"
                title="Descargar CV"
              >
                <Download size={16} />
              </a>
            ) : (
              <span className="text-xs text-gray-400 italic">No hay CV adjunto</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidatoDetalle;
